/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { toggleDividendsReinvestGetResponseSchema } from './toggleDividendsReinvestGetResponseSchema.ts';

export const getToggleDividendsReinvestQueryParamsSchema = z.object({
  investment_product: z.string(),
});

/**
 * @description 200 response
 */
export const getToggleDividendsReinvest200Schema = z.lazy(() => toggleDividendsReinvestGetResponseSchema);

/**
 * @description 505 response
 */
export const getToggleDividendsReinvest505Schema = z.any();

export const getToggleDividendsReinvestQueryResponseSchema = z.lazy(() => getToggleDividendsReinvest200Schema);
